<div class="footerContainer">
  <div class="flex-display justify-content-center overflow-auto">
    <a class="cursor-pointer" *ngFor="let obj of footerLinkData" [tabindex]="obj.displayText ? '' : '-1' " [ngClass]="obj.displayText ? 'footer-item' : 'footer-line'" [class.bold]="obj.isBold" (click)="footer(obj,$event)" (contextmenu)="onRightClick($event,obj)">
      {{obj.displayText}}
    </a>
  </div>
</div>
<div class="footer-bread-crumb-container" *ngIf="(navData && navData.crumbData != null) || printOption || displayOption">
  <div *ngIf="!(navData && navData.crumbData != null)" class="w-63 float-L"></div>
  <div *ngIf="navData && navData.crumbData != null" class="w-63 float-L">
    <div *ngIf="navData.crumbData.length > 0" class="footer-bread-crumb-container">
      <div *ngFor="let crumbObj of navData.crumbData, index as i" class="bread-crumb" [class.bread-crumb-selected]="i === (navData.crumbData.length - 1) && (!route.url.includes('showallinonepage'))">
        <div *ngIf="(i === (navData.crumbData.length - 1))" class="flex-display">
          <div *ngIf="showFooterMenu" class="footer-menu-container float-L">
            <div class="flex-display justify-content-flex-end">
              <button mat-raised-button id="close-footer-menu-btn" (click)="closeFooterMenu()">
                Close <img src="../../../assets/icons/temp/close-white.svg" class="close-icon-image" alt="Close Left Menu Option">
              </button>
            </div>
            <div class="footer-menu-data-container">
              <div *ngFor="let obj of breadCrumbMenuData" (click)="ChangeSelectedItem(obj, (crumbObj === obj.menuItem || obj.menuRollUp == 'False') && obj.childData.length > 0 , crumbObj === obj.menuItem)" class="footer-menu-element flex-display" >
                <div class="align-self-center bread-crump-popup-text footer-menu-item" tabindex="0"  (keyup.enter)="ChangeSelectedItem(obj, (crumbObj === obj.menuItem|| obj.menuRollUp == 'False') && obj.childData.length > 0, crumbObj === obj.menuItem)" [innerHTML]="obj.menuItem" *ngIf="crumbObj != obj.menuItem">
                </div>
                <div class="align-self-center bread-crump-popup-text footer-menu-item" *ngIf="crumbObj === obj.menuItem" [innerHTML]="obj.menuItem" [class.footer-menu-element-disabled]="((crumbObj === obj.menuItem && obj.childData.length == 0)||(obj.menuRollUp == 'False'))" [class.footer-menu-element-bold]="crumbObj === obj.menuItem && obj.childData.length > 0">
                </div>
                <div class="m-Auto" *ngIf="((crumbObj === obj.menuItem || obj.menuRollUp == 'False') && obj.childData.length > 0)">
                  <mat-icon>keyboard_arrow_right</mat-icon>
                </div>
              </div>
              <div class="footer-menu-element flex-display" *ngIf="(!isEffectiveDate) && isContentpage && isShowAllRequired(breadCrumbMenuData)">
                <div class=" flex-display align-self-center bread-crump-popup-text footer-menu-item" (click)="ShowallInonepage(breadCrumbMenuData)" (keyup.enter)="ShowallInonepage(breadCrumbMenuData)">
                  <div class="m-Auto">
                    <mat-icon>filter_none</mat-icon>
                  </div>&nbsp; &nbsp;
                  <div class="navName m-Auto">
                    Show all in one page
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div *ngIf="showChildMenu && childMenuData.length > 0" class="footer-child-container float-R">
            <div class="flex-display justify-content-flex-end">
              <button mat-raised-button id="close-footer-menu-btn" (click)="showChild()">
                Close <img src="../../../assets/icons/temp/close-white.svg" class="close-icon-image" alt="Close Left Menu Option">
              </button>
            </div>
            <div class="footer-menu-data-container">
              <div *ngFor="let obj of childMenuData" (click)="ChangeSelectedPage(obj)" tabindex="0" (keyup.enter)="ChangeSelectedPage(obj)" class="footer-menu-element flex-display">
                <div class="align-self-center bread-crump-popup-text footer-menu-item" [innerHTML]="obj.menuItem">
                </div>
              </div>
            </div>
          </div>
        </div>
        <div tabindex="0" class="bread-crumb-text flex-display" (keyup.enter)="footerMenuClicked(i === (navData.crumbData.length - 1))" (click)="footerMenuClicked(i === (navData.crumbData.length - 1))">
          <div class="overflow-elipses font-14" [innerHTML]="crumbObj">
          </div>
          <div class="font-14" *ngIf="!route.url.includes('showallinonepage')">
            <mat-icon *ngIf="i === (navData.crumbData.length - 1) && !showFooterMenu" [inline]="true">keyboard_arrow_up</mat-icon>
            <mat-icon *ngIf="i === (navData.crumbData.length - 1)&& showFooterMenu" [inline]="true">keyboard_arrow_down</mat-icon>
          </div>
        </div>
        <div *ngIf="i != (navData.crumbData.length - 1)">
          <img src="../../../assets/icons/Arrow-Right-light.svg" class="bread-crumb-icon" alt="Arrow Right">
        </div>
      </div>
    </div>
  </div>
  <div class="float-R" *ngIf="printOption">
    <div class="footer-bread-crumb-data-print-display">
      <div class="bread-crumb" tabindex="0">
        <div *ngIf="showFooterPrintMenu" class="footer-printDisplay-menu-container">
          <div class="flex-display justify-content-flex-end" (keyup.enter)="footerPrintClicked()" (click)="footerPrintClicked()">
            <button mat-raised-button id="close-footer-menu-btn">
              Close <img src="../../../assets/icons/temp/close-white.svg" class="close-icon-image" alt="Close Print Option">
            </button>
          </div>
          <div class="footer-menu-data-container">
            <div *ngFor="let printobj of PrintValue; let i = index">
              <div *ngIf="printobj.labels == 'Include Annotations' && printobj.DisplayOrNot && !isArchive" class="footer-menu-annotation-element flex-display">
                <div class="align-self-center bread-crump-popup-text footer-menu-item">
                  {{ printobj.labels }}
                </div>
                <div *ngIf="printobj.toggle" class="flex-display-print-trash" tabindex="0">
                  <mat-slide-toggle class="m-auto-0" [class.annotationToggleTrue]="!annotationToggle" [class.annotationToggleFalse]="annotationToggle" [checked]="annotationToggle" (change)="toggle($event)"></mat-slide-toggle>
                </div>
              </div>
              <div *ngIf="printobj.labels != 'Include Annotations' && printobj.DisplayOrNot" class="footer-menu-display-element flex-display print-display" (keyup.enter)="footerPrintClicked()" (click)="footerPrintClicked()">
                <div class="align-self-center bread-crump-popup-text footer-menu-item" (click)="printpreview(printobj)" (Key.enter)="printpreview(printobj)">
                  {{ printobj.labels }}  <span *ngIf="printQueueCount >= 0 && printobj.deletedIcon">({{printQueueCount}})</span>
                </div>
                <div *ngIf="printobj.deletedIcon" class="flex-display-print-trash">
                  <img src="../../../assets/icons/trash-red.svg" class="close-icon-image cursor-pointer" alt="Delete" title="Delete" (click)="deletePrintQueue(printobj)" (keyup.enter)="deletePrintQueue(printobj)" tabindex="0">
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="bread-crumb-selected flex-display" (keyup.enter)="footerPrintClicked()" (click)="footerPrintClicked()">
          <img src="../../../assets/icons/Print-white.svg" class="close-icon-image" alt="Print"><span class="close-icon-image underline font-14">
            {{globalprint}}  <label *ngIf="printQueueCount > 0">({{printQueueCount}})</label>
          </span>
          <div class="font-14">
            <mat-icon *ngIf="!showFooterPrintMenu" [inline]="true">keyboard_arrow_up</mat-icon>
            <mat-icon *ngIf="showFooterPrintMenu" [inline]="true">keyboard_arrow_down</mat-icon>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="float-R" *ngIf="displayOption && !isArchive">
    <div class="footer-bread-crumb-data-print-display">
      <div (click)="footerDisplayClicked()" class="bread-crumb" tabindex="0" (keyup.enter)="footerDisplayClicked()">
        <div *ngIf="showFooterDisplayMenu" class="footer-printDisplay-menu-container">
          <div class="flex-display justify-content-flex-end">
            <button mat-raised-button id="close-footer-menu-btn">
              Close <img src="../../../assets/icons/temp/close-white.svg" class="close-icon-image" alt="Close Display Option">
            </button>
          </div>
          <div class="footer-menu-data-container">
            <div *ngFor="let obj of DisplayValue; let i = index">
              <div class="print-display" *ngIf="obj.DisplayOrNot">
                <div class="footer-menu-display-element flex-display" (click)="displayAll(obj)">
                  <div class="align-self-center mr-5">
                    <img src="{{obj.imgPath}}" class="flex-display-icon" alt="{{obj.alt}}" />
                  </div>
                  <div id="{{obj.id}}" class="align-self-center bread-crump-popup-text footer-menu-item print-display float-R">
                    {{obj.labels}}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="bread-crumb-selected flex-display">
          <img src="../../../assets/icons/Display-white.svg" class="close-icon-image" alt="Display"><span class="close-icon-image underline font-14">{{displayLabel}}</span>
          <div class="font-14">
            <mat-icon *ngIf="!showFooterDisplayMenu" [inline]="true">keyboard_arrow_up</mat-icon>
            <mat-icon *ngIf="showFooterDisplayMenu" [inline]="true">keyboard_arrow_down</mat-icon>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

